import * as React from 'react';
import PropTypes from 'prop-types';
import ol_Map from 'ol/Map';
import ol_control_Rotate from 'ol/control/Rotate';
import { Util } from '../util';

import Map from '../map';

export class Rotate extends React.Component {
    constructor(props) {
        super(props);
        this.options = {
            className: undefined,
            label: undefined,
            tipLabel: undefined,
            duration: undefined,
            autoHide: undefined,
            render: undefined,
            resetNorth: undefined,
            target: undefined
        };
        this.events = {
            'change': undefined,
            'propertychange': undefined
        };
    }
    render() { return null; }
    componentDidMount() {
        let options = Util.getOptions(Object['assign'](this.options, this.props));
        this.control = new ol_control_Rotate(options);
        this.context.mapComp.controls.push(this.control);
        let olEvents = Util.getEvents(this.events, this.props);
        for (let eventName in olEvents) {
            this.control.on(eventName, olEvents[eventName]);
        }
    }
}
Rotate['contextTypes'] = {
    mapComp: PropTypes.instanceOf(Map),
    map: PropTypes.instanceOf(ol_Map)
};